import React from 'react';
import { injectIntl } from 'react-intl';

import { StyledInline } from 'modules/log/LogItem/styled';
import t_logs from 'modules/log/t-logs';
import tlogs_es from 'modules/log/t-logs_es';
import { IS_TENANT } from 'tenant/config';

const getReasonLiteral = ({ action, reason, t: { reasons = {} } = {} }) => {
  if (reason === 'REASON_OTHER') {
    return '';
  }

  if (!reasons[action]) {
    return reason;
  }

  if (!reasons[action] && !reasons[action][reason]) {
    return '';
  }

  return reasons[action][reason];
};

const Reason = ({ intl, action, reason, ...props }) => {
  const logs_messages = IS_TENANT ? tlogs_es : t_logs;
  const reasonFormatted = getReasonLiteral({ action, reason, t: logs_messages });

  return (
    !!reasonFormatted && (
      <>
        <StyledInline color="grey700"> / </StyledInline>
        <StyledInline bold color="grey700">
          {reasonFormatted}
        </StyledInline>
      </>
    )
  );
};

export default injectIntl(Reason);
